import { WithStyles, createStyles, Typography, Grid } from '@material-ui/core';
import { Theme } from '@material-ui/core';

let styles

export default styles = (theme: Theme) => createStyles({
    questionCarousel: {
        padding: "12px 20px",
        background: "#FFFFFF",
        boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.06)",
        borderRadius: "4px",
        margin: '20px 0',
    },
    questionSlideSec: {
        display: "inline-block",
        width: "calc(100% - 60px)",
        verticalAlign: "middle",
        "& .slick-slider": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 23px 0 32px",
            "& .slick-prev": {
                top: "10px",
                left: "0",
                transform: "none",  
                width: "24px",
                height: "24px",
                background: "#FFFFFF",
                boxShadow: "0px 0px 4px rgb(0 0 0 / 20%)",
                borderRadius: "30px",
                zIndex: 1,
                backgroundImage: "url(/assets/svg/prev-ic.svg)",
                backgroundSize: "5px",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                "&.slick-disabled": {  
                    display: "none !important"
                },
                "&:before": {
                    display: "none",
                }
            },
            "& .slick-next": {
                top: "10px",
                right: "0",
                transform: "none",  
                width: "24px",
                height: "24px",
                background: "#FFFFFF",
                boxShadow: "0px 0px 4px rgb(0 0 0 / 20%)",
                borderRadius: "30px",
                zIndex: 1,
                backgroundImage: "url(/assets/svg/next-ic.svg)",
                backgroundSize: "5px",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                "&.slick-disabled": {  
                    display:'none !important'
                },
                "&:before": {
                    display: "none",
                }
            },
            "& .slick-list": {
                width: "100%",
                height: "44px",
                margin: "0 10px 0 0",
                "& .slick-track": {
                    position: "absolute",
                    right: "0",
                    transition: "all 0.9s",
                },
                "& .slick-slide": {
                    "& div": {
                        width: "44px",
                        height: "44px",
                        margin: "0 auto",
                        "& .item": {
                            textAlign: "center",
                            padding: "10px 5px",
                            cursor: "pointer",
                            background: "#FFFFFF",
                            border: "1px solid #E6E6E6",
                            borderRadius: "4px",
                            fontWeight: 400,
                            fontSize: "16px",
                            color: "#666666",
                            lineHeight: "22px",
                        },
                        "& .filled": {
                            backgroundColor: "#30BE76",
                            borderColor: "#30BE76",
                            color: "#ffffff",
                        },
                        "& .current": {
                            borderColor: "#1D7DEA",
                        },
                    },
                }
            },
        },
    },
    questionDropdownGroup: {
        display: "inline-block",
        width: "44px",
        height: "44px",
        verticalAlign: "middle",
        marginLeft: "16px",
        position: "relative",
    },
    questionDropdown: {
        width: "44px",
        height: "44px",
        textAlign: "center",
        background: "#FFFFFF",
        border: "1px solid #E6E6E6",
        borderRadius: "8px",
        cursor: "pointer",
        "& span": {
            width: "3px",
            height: "3px",
            borderRadius: "50%",
            backgroundColor: "#666666",
            margin: "0 1px",
            display: "inline-block",
            verticalAlign: "middle",
        }
    },
    questionDropdownMenu: {
        width: "372px",
        minWidth: "372px",
        padding: "20px",
        backgroundColor: "#ffffff",
        boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        right: "-12px",
        top: "70px",
        position: "absolute",
        zIndex: 1,
        "& .dropdownarrow": {
            position: "absolute",
            top: "-10px",
            right: "22px",
        },
        "& h6": {
            fontSize: "16px",
            fontWeight: 400,
            color: "#666666",
            margin: "0",
        },
        "& .listing": {
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            listStyle: "none",
            paddingLeft: "0",
            margin: "0 -9px",
            overflowY: "auto",
            "& li": {
                width: "calc(100%/7 - 18px)",
                height: "32px",
                margin: "20px 9px 0",
                border: "solid 1px #E6E6E6",
                borderRadius: "4px",
                fontSize: "14px",
                fontWeight: 400,
                color: "#666666",
                lineHeight: "19.1px",
                padding: "6.5px 6.5px",
                textAlign: "center",
                cursor: "pointer",
                "&.current": {
                    borderColor: "#1D7DEA",
                    color: "#1D7DEA",
                },
                "&.filled": {
                    borderColor: "#30BE76",
                    backgroundColor: "#30BE76",
                    color: "#ffffff",
                    "&.current": {
                        borderColor: "#1D7DEA",
                    },
                },
                "&:hover": {
                    borderColor: "#1D7DEA",
                    color: "#1D7DEA",
                },
            },
        }
    },
});
